export const getStorageAsset = (name) => {
  return `/storage/${name}`
}
